import React, { FC, memo, useEffect, useState } from 'react'
import classes from './SingleInputItem.module.scss'
import { Dirary } from '../../../../types/dirary'
//削除アイコン
import DeleteIcon from '@mui/icons-material/Delete'
//コメントアイコン
import CommentIcon from '@mui/icons-material/Comment'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import TextInputForProductNo from '../../../uikit/atoms/textfields/TextInputForProductNo'
import TextInputForproductBno from '../../../uikit/atoms/textfields/TextInputForProductBno'
import SelectBoxForNumber from '../../../uikit/atoms/selectboxes/SelectBoxForNumber'
import { factoriesForInput } from '../../../../utils/variables/factoriesForInupt'
import { constructionsForInput } from '../../../../utils/variables/constructions'
import { workingTimeList } from '../../../../utils/variables/workingTimeList'
import { userState } from '../../../../states/userState'
import { useRecoilState } from 'recoil'
import { User } from '../../../../types'
import { setUserToLocalStorage } from '../../../../utils/functions/localStorageManager'
import { useGetProcessees } from '../../../../hooks/api/processes/useGetProcesses'
import SelectBoxForString from '../../../uikit/atoms/selectboxes/SelectBoxForString'
import { calcTotalTimeByDiary } from '../../../../utils/functions/calcTotalTime'
import { productNoFocusState } from '../../../../states/variableState'
import { useCheckSendable } from '../../../../hooks/singleInput/useCheckSendable'
import InputComment from '../../../modal/Input/InputComment'
type Props = {
  id: number
  diaryList: Array<Dirary>
  setDiaryList: React.Dispatch<React.SetStateAction<Dirary[]>>
  setTotalTime: React.Dispatch<
    React.SetStateAction<{ hour: number; min: number; text: string }>
  >
}
export type processListType = {
  id: string
  name: string
  processId: string
  processName: string
  estimatedTime: number
  slipNumber: string
}

const SingleInputItem: FC<Props> = memo((props) => {
  const [isShowCommentModal, setIsShowCommentModal] = useState(false)
  const { checkDiarySendable } = useCheckSendable()
  const [productFocusState, setProductFocusState] =
    useRecoilState(productNoFocusState)
  const [user, setUser] = useRecoilState(userState)
  const { getProcesses } = useGetProcessees()
  const theme = useTheme()
  const { id, diaryList, setDiaryList, setTotalTime } = props
  //製番2フォーカス移動時に入力値を保持するためのstate
  const [toggBnoClear, setToggleBnoClear] = useState(false)
  const [diary, setDiary] = useState<Dirary>(
    diaryList.find((diary) => diary.id === id) as Dirary
  )
  //製番1
  const [productNo, setProductNo] = useState(
    diary.productNo.length > 0 ? String(diary.productNo).padStart(8, '0') : ''
  )
  //製番2
  const [productBno, setProductBno] = useState(
    diary.productBno.length > 0 ? String(diary.productBno).padStart(2, '0') : ''
  )

  //製作工場
  const [factoryId, setFactoryId] = useState(diary.factoryId)
  //工事区分
  const [constructionId, setConstructionId] = useState(diary.constructionId)
  //作業時間
  // const [workingTime, setWorkingTime] = useState({
  //   hour: diary.workingTimeByHour,
  //   min: diary.workingTimeByMinute,
  // });
  //現場名
  // const [siteName, setSiteName] = useState(diary.siteName);
  //工程リスト
  const defaultList = [
    {
      id: '0000000',
      slipNumber: '0000000',
      processId: '0000',
      processName: '未選択',
      estimatedTime: 0,
      name: '未選択',
    },
  ]
  const [processList, setProcessList] = useState<processListType[]>(defaultList)
  //伝票番号
  const [slipNo, setSlipNo] = useState(diary.slipNumber)
  // //工程番号
  // const [ProcessId, setProcessId] = useState(diary.processId);
  // //工程名
  // const [ProcessName, setProcessName] = useState(diary.processName);
  // //予定工数
  // const [estimatedTime, setEstimatedTime] = useState(diary.estimatedTime);
  // //作業時間
  // const [workingTimeByHour, setWorkingTimeByHour] = useState(
  //   diary.totalWorkingTimeByHour
  // );
  // const [workingTimeByMinute, setWorkingTimeByMinute] = useState(
  //   diary.totalWorkingTimeByMinute
  // );
  //削除処理
  const handleDeleteButtonClick = () => {
    setDiaryList((prevState) => prevState.filter((diary) => diary.id !== id))
  }
  //工場変更
  const handleFactoryChange = (e: number) => {
    setFactoryId(e)
    // setDiaryList((prevState) =>
    //   prevState.map((diary) => {
    //     if (diary.id === id) {
    //       return { ...diary, factoryId: e };
    //     }
    //     return diary;
    //   })
    // );
    setDiary((prevDiary) => {
      return { ...prevDiary, factoryId: e }
    })
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          factoryNoForSingleInput: e,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
  }
  //工事区分変更
  const handleConstructionChange = (e: number) => {
    setConstructionId(e)
    setDiary((prevDiary) => {
      return { ...prevDiary, constructionId: e }
    })
    setUser((prevUser: User) => {
      const newUser: User = {
        ...prevUser,
        initialParameters: {
          ...prevUser.initialParameters,
          constructionForSingleInput: e,
        },
      }
      setUserToLocalStorage(newUser)
      return newUser
    })
  }
  //作業時間変更
  const handleWorkingTimeChange = (e: number) => {
    const hour = e
    const min = hour * 60
    setDiary((prevDiary) => {
      return {
        ...prevDiary,
        workingTimeByHour: hour,
        workingTimeByMinute: min,
      }
    })
  }
  //製番1変更
  const handleChangeProductNo = (e: string) => {
    setDiary((prevDiary) => {
      return { ...prevDiary, productNo: e }
    })
  }
  useEffect(() => {
    handleChangeProductNo(productNo)
  }, [productNo])
  //製番2変更
  const handleChangeProductBno = (e: string) => {
    setDiary((prevDiary) => {
      return { ...prevDiary, productBno: e }
    })
  }
  useEffect(() => {
    handleChangeProductBno(productBno)
  }, [productBno])
  //工程検索用API実行
  useEffect(() => {
    const fetchProcesses = async () => {
      if (productNo.length < 8 || productBno.length < 2) {
        if (
          // productNo.length === 0 ||
          // productBno.length === 0
          productFocusState &&
          (user.initialParameters.productNoForSingleInput.length === 0 ||
            user.initialParameters.productBnoForSingleInput.length === 0)
        ) {
          clearProcessParams('製番を入力してください')
          setProductFocusState(false)
        }
        return
      }
      const res = await getProcesses(productNo, productBno)
      if (res[0][0] < 0) {
        let disp = '工程データが見つかりません' //-3
        if (res[0][0] === -1) {
          disp = '受注データが見つかりません'
        } else if (res[0][0] === -2) {
          disp = '原価確定済です'
        }
        clearProcessParams(disp)
      } else {
        //工程が取得できた場合
        setProcessList(() => {
          const newProcessList = res.map((data: any) => {
            return {
              id: data[2],
              processId: data[0],
              processName: data[1],
              estimatedTime: data[4],
              slipNumber: data[2],
              name: data[1],
            }
            // {
            //   id: "0000000",
            //   slipNumber: "0000000",
            //   processId: "0000",
            //   processName: "製番を入力してください",
            //   estimatedTime: 0,
            //   name: "製番を入力してください",
            // },
          })
          setDiary((prevDiary) => {
            let newSlipNumber =
              prevDiary.slipNumber === '0000000'
                ? res[0][2]
                : prevDiary.slipNumber
            if (productNo === '99999999' && productBno === '99') {
              //前ゼロを削除
              newSlipNumber = String(Number(newSlipNumber))
            }
            const process = newProcessList.find(
              (process: any) => process.id === newSlipNumber
            )
            const newDiary = {
              ...prevDiary,
              processId: process ? process.processId : '0000',
              processName: process ? process.processName : '未設定',
              estimatedTime: process ? process.estimatedTime : 0,
              slipNumber: newSlipNumber,
              siteName: res[0][3],
              productNo: productNo,
              productBno: productBno,
            }
            setUser((prevUser: User) => {
              const newUser: User = {
                ...prevUser,
                initialParameters: {
                  ...prevUser.initialParameters,
                  productNoForSingleInput: productNo,
                  productBnoForSingleInput: productBno,
                  slipNumberForSingleInput: newSlipNumber,
                },
              }
              setUserToLocalStorage(newUser)
              return newUser
            })

            return newDiary
          })
          return newProcessList
        })
      }
    }
    fetchProcesses()
    // getProcesses();
  }, [
    // user.initialParameters.productNoForSingleInput,
    // user.initialParameters.productBnoForSingleInput,
    productNo,
    productBno,
  ])
  //パラメータクリア処理
  const clearProcessParams = (disp: string) => {
    if (diary.slipNumber === '0000000' || disp === '製番を入力してください') {
      setDiary((prevDiary) => {
        const newDiary = {
          ...prevDiary,
          siteName: disp,
          slipNumber: '0000000',
          processId: '0000',
          processName: '未設定',
          estimatedTime: 0,
          productNo: productNo,
          productBno: productBno,
          isDisabled: false,
        }
        return newDiary
      })
      setUser((prevUser: User) => {
        const newUser: User = {
          ...prevUser,
          initialParameters: {
            ...prevUser.initialParameters,
            productNoForSingleInput: productNo,
            productBnoForSingleInput: productBno,
            slipNumberForSingleInput: '0000000',
          },
        }
        setUserToLocalStorage(newUser)
        return newUser
      })
      setProcessList(defaultList)
    } else {
      setDiary((prevDiary) => {
        const newDiary = {
          ...prevDiary,
          isDisabled: true,
          productNo: productNo,
          productBno: productBno,
        }
        return newDiary
      })
      setUser((prevUser: User) => {
        const newUser: User = {
          ...prevUser,
          initialParameters: {
            ...prevUser.initialParameters,
            productNoForSingleInput: productNo,
            productBnoForSingleInput: productBno,
          },
        }
        setUserToLocalStorage(newUser)
        return newUser
      })
      const fixedList = [
        {
          id: diary.slipNumber,
          slipNumber: diary.slipNumber,
          processId: diary.processId,
          processName: diary.processName,
          estimatedTime: diary.estimatedTime,
          name: diary.processName,
        },
      ]
      setProcessList(fixedList)
    }
  }
  //工程が変更されたとき
  const handleProcessChange = (e: string) => {
    const process = processList.find((process) => process.id === e)
    if (process) {
      setDiary((prevDiary: Dirary) => {
        return {
          ...prevDiary,
          processId: process.processId,
          processName: process.processName,
          estimatedTime: process.estimatedTime,
          slipNumber: process.slipNumber,
          productNo: productNo,
          productBno: productBno,
        }
      })
      setUser((prevUser: User) => {
        const newUser: User = {
          ...prevUser,
          initialParameters: {
            ...prevUser.initialParameters,
            slipNumberForSingleInput: process.slipNumber,
            productBnoForSingleInput: productBno,
            productNoForSingleInput: productNo,
          },
        }
        setUserToLocalStorage(newUser)
        return newUser
      })
    }
  }

  //日報配列更新・送信判定処理
  useEffect(() => {
    const checkResult = checkDiarySendable(diary)
    if (checkResult === 0) {
      setDiary((prevDiary) => {
        const newDiary = { ...prevDiary, isSendable: true }
        setDiaryList((prevState) =>
          prevState.map((prevDiary) => {
            if (prevDiary.id === id) {
              return newDiary
            }
            return prevDiary
          })
        )
        return newDiary
      })
    } else {
      setDiary((prevDiary) => {
        const newDiary = { ...prevDiary, isSendable: false }
        setDiaryList((prevState) =>
          prevState.map((prevDiary) => {
            if (prevDiary.id === id) {
              return newDiary
            }
            return prevDiary
          })
        )
        return newDiary
      })
    }
  }, [
    diary.comment,
    diary.processId,
    diary.processName,
    diary.slipNumber,
    diary.productNo,
    diary.constructionId,
    diary.productNo,
    diary.productBno,
    diary.factoryId,
    diary.workingTimeByHour,
    diary.workingTimeByMinute,
    diary.siteName,
    diary.estimatedTime,
    // diary.workingDate,
  ])
  //合計作業時間更新
  useEffect(() => {
    const newDiary = diaryList.find((diary) => diary.id === id) as Dirary
    setDiary((prevDiary) => {
      return {
        ...prevDiary,
        startTime: newDiary.startTime,
        endTime: newDiary.endTime,
        totalWorkingTimeByHour: newDiary.totalWorkingTimeByHour,
        totalWorkingTimeByMinute: newDiary.totalWorkingTimeByMinute,
        isBreak: newDiary.isBreak,
      }
    })
  }, [diaryList])
  useEffect(() => {
    const newDiary = diaryList.find((diary) => diary.id === id) as Dirary
    setDiary(newDiary)
  }, [diaryList[0].id])

  return (
    <div
      className={classes.rootContainer}
      style={{
        borderRight: `5px solid ${
          diary.isSendable
            ? theme.palette.foreColor.success
            : theme.palette.foreColor.error
        }`,
      }}
    >
      <div
        style={
          diary.isDisabled
            ? {
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: '#898b92',
                opacity: 0.3,
                zIndex: 10,
                borderRadius: '5px',
              }
            : {}
        }
      ></div>
      <div className={classes.firstLine}>
        <div className={classes.productNo}>
          <div className={classes.ProductNo1}>
            <TextInputForProductNo
              fullWidth={false}
              label={''}
              multiline={false}
              required={false}
              type={'number'}
              rows={1}
              disabled={false}
              // InputProps={true}
              placeholder={'01234567'}
              productNo={productNo}
              setProductNo={setProductNo}
              productBno={productBno}
              setProductBno={setProductBno}
              colorMode={'dark'}
              setMode={'inputSingle'}
              setToggleBnoClear={setToggleBnoClear}
            />
          </div>
          <span className={classes.hyphen}>-</span>
          <div className={classes.ProductNo2}>
            <TextInputForproductBno
              fullWidth={false}
              label={''}
              multiline={false}
              required={false}
              type={'number'}
              rows={1}
              disabled={false}
              // InputProps={true}
              placeholder={'01'}
              productNo={productNo}
              setProductNo={setProductNo}
              productBno={productBno}
              setProductBno={setProductBno}
              colorMode={'dark'}
              setMode={'inputSingle'}
              toggleBnoClear={toggBnoClear}
            />
          </div>
        </div>
        <div className={classes.factory}>
          <SelectBoxForNumber
            label={''}
            options={factoriesForInput}
            required={true}
            select={handleFactoryChange}
            value={factoryId}
            disabled={false}
            width={'85px'}
            height={'38px'}
            fontSize={'12px'}
            colorMode={'dark'}
            setMode={'input'}
          />
        </div>
        <div className={classes.construction}>
          <SelectBoxForNumber
            label={''}
            options={constructionsForInput}
            required={true}
            select={handleConstructionChange}
            value={constructionId}
            disabled={false}
            width={'85px'}
            height={'38px'}
            fontSize={'12px'}
            colorMode={'dark'}
            setMode={'input'}
          />
        </div>
      </div>
      <div className={classes.secondLine}>
        <div className={classes.siteName}>
          <p>{diary.siteName}</p>
        </div>
        {/* <div className={classes.process}>
          <p>{diary.processName}</p>
        </div>
        <div className={classes.estimatedTime}>
          <p>{`${diary.estimatedTime}時間`}</p>
        </div> */}
        <Tooltip title="削除" placement="bottom">
          <div className={classes.deleteButton}>
            <IconButton
              component="label"
              disabled={false}
              onClick={handleDeleteButtonClick}
              sx={{
                color: '#cccccc',
                height: 12,
                width: 12,
              }}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        </Tooltip>
      </div>
      <div className={classes.hr} />
      <div className={classes.thirdLine}>
        <div className={classes.process}>
          <div className={classes.processName}>
            <SelectBoxForString
              label={''}
              options={processList}
              required={true}
              select={handleProcessChange}
              value={diary.slipNumber}
              disabled={false}
              width={'190px'}
              height={'32px'}
              fontSize={'16px'}
              setMode={'input'}
              colorMode={'dark'}
            />
          </div>
          <div className={classes.processIds}>
            <div>
              <p className={classes.title}>工程番号</p>
              <p>{diary.processId}</p>
            </div>
            <div>
              <p className={classes.title}>伝票番号</p>
              <p>{diary.slipNumber}</p>
            </div>
            <div>
              <p className={classes.title}>予定工数</p>
              <p>{Number(diary.estimatedTime).toFixed(2)}H</p>
            </div>
            <Tooltip title="コメント" placement="right">
              <div className={classes.comment}>
                <p>コメント</p>

                <IconButton
                  component="label"
                  disabled={false}
                  onClick={() => setIsShowCommentModal(true)}
                  sx={
                    diary.comment.length > 0
                      ? {
                          color: theme.palette.foreColor.error,
                          height: 12,
                          width: 12,
                        }
                      : {
                          color: theme.palette.foreColor.light,
                          height: 12,
                          width: 12,
                        }
                  }
                >
                  <CommentIcon />
                </IconButton>
              </div>
            </Tooltip>
          </div>
        </div>
        <div className={classes.time}>
          <div className={classes.workingTime}>
            <p>作業時間(H)</p>
            <div>
              <SelectBoxForNumber
                label={''}
                options={workingTimeList}
                required={true}
                select={handleWorkingTimeChange}
                value={diary.workingTimeByHour}
                disabled={false}
                width={'70px'}
                height={'20px'}
                fontSize={'20px'}
                colorMode={'dark'}
                setMode={'input'}
              />
            </div>
          </div>
        </div>
      </div>

      {isShowCommentModal && (
        <InputComment
          setIsShow={setIsShowCommentModal}
          setDiary={setDiary}
          diary={diary}
          isReadOnly={diary.isDisabled}
        />
      )}
    </div>
  )
})

export default SingleInputItem
